<template>
  <div class="specific-people-info-container">
    <div style="display: flex; align-items: center">
      <h2>Executors</h2>
      <div v-if="hasToReviseExecutors" class="revise-notice">
        <div class="revise-step-content">
          <img
            :src="syncCircleSvg"
            alt="Sync Circle Icon"
            class="completed-tick"
          />
          Update step
        </div>
      </div>
    </div>

    <div class="mb-4">
      <h3>Main Executor(s)</h3>
      <div v-if="testator.executorParty == 'FRIEND_OR_FAMILY'">
        <p>
          {{ relations.executor.fullName }}
          <span v-show="relations.executor.kinship">-</span>
          {{ formatPersonKinship(relations.executor.kinship) }}
        </p>
      </div>

      <p v-if="testator.executorParty == 'INTERNAL_COMPANY'">
        {{ whitelabel.internalExecutorName }}
      </p>
      <p v-if="testator.executorParty == 'ADVISOR_COMPANY' && testator.company">
        {{ testator.company.tradingName }}
      </p>

      <div v-if="relations.coExecutor.id">
        <p>
          {{ relations.coExecutor.fullName }}
          <span v-show="relations.coExecutor.kinship">-</span>
          {{ formatPersonKinship(relations.coExecutor.kinship) }}
        </p>
      </div>
    </div>

    <div v-if="!omOnlyExecutor" class="mb-4">
      <h3>Alternative Executor</h3>
      <div v-if="testator.alternativeExecutorParty == 'FRIEND_OR_FAMILY'">
        <p>
          {{ relations.alternativeExecutor.fullName }}
          <span v-show="relations.alternativeExecutor.kinship">-</span>
          {{ formatPersonKinship(relations.alternativeExecutor.kinship) }}
        </p>
      </div>

      <div class="mb-4">
        <p v-if="testator.alternativeExecutorParty == 'INTERNAL_COMPANY'">
          {{ whitelabel.internalExecutorName }}
        </p>
        <p
          v-if="
            testator.alternativeExecutorParty == 'ADVISOR_COMPANY' &&
            testator.company
          "
        >
          {{ testator.company.tradingName }}
        </p>
        <p v-if="!testator.alternativeExecutorParty">Not selected</p>
      </div>
    </div>
    <div class="card-button-container">
      <FunkButton
        :button-text="`${omOnlyExecutor ? 'View' : 'Edit'}`"
        @buttonClicked="edit"
      />
    </div>
  </div>
</template>

<script>
  import { formatKinship } from '../../constants/js/people.js';
  import syncCircleSvg from '@/assets/shared/sync_circle.svg';
  import Revise from '../../helpers/reviseStep';

  export default {
    name: 'ExecutorOverview',
    props: {
      testator: {
        type: Object,
        required: true,
      },
      relations: {
        type: Object,
        required: true,
      },
    },
    data: () => ({
      syncCircleSvg: syncCircleSvg,
    }),
    methods: {
      edit() {
        this.$router.push({
          name: 'AppointExecutor',
          query: { peopleWizard: 'executor' },
        });
      },
      formatPersonKinship(kinship) {
        return formatKinship(kinship, this.testator);
      },
    },
    computed: {
      hasToReviseExecutors() {
        return Revise.step_2_internal_executor_updates_to_revise(this.testator);
      },
      omOnlyExecutor() {
        if (this.testator.bypassOmOnlyExecutor) {
          return false;
        }
        return (this.testator.enabledFeatures || []).includes(
          'om_only_executor'
        );
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '../../constants/styles/people-overview-info-blocks.scss';

  .revise-notice {
    // background color in global.scss because of IE issue
    color: white;
    border-radius: 13px;
    padding: 1px 8px;
    font-size: 12px;
    display: inline-block;
    margin-bottom: 6px;
    margin-left: 12px;

    .completed-tick {
      height: 15px;
      width: 15px;
      margin-right: 2px;
      margin-top: -3px;
    }
  }

  .revise-step-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 12px;
    font-weight: bold;
    line-height: 1.375rem;
  }
  .revise-step-content img {
    margin-top: 0 !important;
  }
</style>
